import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/translation/catalog/translation.catalog.query.gql"
import type {
  TranslationCatalogQuery,
  TranslationCatalogQueryVariables,
} from "@/v2-backoffice-client/translation/catalog/__types__/translation.catalog.query"

type Options = QueryHookOptions<
  TranslationCatalogQuery,
  TranslationCatalogQueryVariables
>

export function useTranslationCatalogQuery(options?: Options) {
  return useQuery<TranslationCatalogQuery, TranslationCatalogQueryVariables>(
    query,
    options,
  )
}
